import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import BugLoggerRoot from './components/BugLogger/BugLoggerRoot';
import { registerAuthServiceWorker } from './auth/authClient';
import clearLegacyTokens from './auth/clearLegacyTokens';
import { logError } from './helpers/bugLogger';
import { clients } from './host';
// import * as serviceWorker from './serviceWorker';

// Drop the credentials the pre-Service-Worker build left in localStorage.
// Tokens live in the worker's IndexedDB now, and nothing else reads or clears
// these keys — without this, an upgrading user keeps a valid refresh token in
// localStorage forever.
clearLegacyTokens();

// Register the @vulog/auth Service Worker as early as possible so it is
// active by the time the app finishes fetching config and calls initAuth().
// Non-blocking: the render starts in parallel.
//
// This rejects for real: public/auth-sw.js is generated by scripts/copy-auth-sw
// and gitignored, so any path that skips the pre-hook serves index.html for it
// and registration fails on the MIME type. When the browser supports Service
// Workers but registration fails, there is no Bearer injection — every
// authenticated call 401s and login fails — so the failure must not stay an
// unhandled rejection nobody sees. (A browser with no Service Worker API at all
// gets `null` here, and @vulog/auth runs in the page instead.)
registerAuthServiceWorker().catch(error => {
    console.error('Auth Service Worker registration failed', error);
    logError(error instanceof Error ? error : new Error(String(error)));
});

const render = () => {
    ReactDOM.render(
        <BugLoggerRoot>
            <App />
        </BugLoggerRoot>,
        document.getElementById('root')
    );
};

// L'import reste dans la branche pour que webpack l'élimine des builds.
if (process.env.NODE_ENV === 'development') {
    import('@vulog-internal/vulog-host-switcher/dist/standalone/dev.js')
        .then(({ mountDev }) => mountDev({ appKey: 'fo', hosts: clients }))
        .catch(error => console.error('Host switcher failed to mount', error))
        .then(render);
} else {
    render();
}

// serviceWorker.register({});
